import React from 'react';
import TopBar from './TopBar';
import BottomBar from './BottomBar';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import ErrorDialog from './components/ErrorDialog';

function Layout() {
  return (
    <React.Fragment>
      <TopBar />
      <Outlet />
      <Footer />
      <BottomBar />
      <ErrorDialog />
    </React.Fragment>
  );
}

export default Layout;
